import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const DeleteCircleSvg = () => (
  <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.5 9L15.5 15'
      stroke='#F42020'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.5 9L9.5 15'
      stroke='#F42020'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle
      cx='12.5'
      cy='12'
      r='9.75'
      fill='#FF0000'
      fillOpacity='0.1'
      stroke='#F42020'
      strokeWidth='0.5'
    />
  </svg>
);

export const DeleteCircleIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DeleteCircleSvg} {...props} />
);
